import styled, { css, keyframes } from "styled-components";
import { SvgProps } from "./types";
import { DefaultTheme } from "styled-components";


const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const spinStyle = css`
    animation: ${rotate} 2s linear infinite;
`;

const Svg = styled.svg<SvgProps>`
    align-self: center; // Safari fix
    flex-shrink: 0;
    ${({ spin }) => spin && spinStyle};

    // Safari fix
    @supports (-webkit-text-size-adjust: none) and (not (-ms-accelerator: true)) and (not (-moz-appearance: none)) {
        filter: none !important;
    }
`;

Svg.defaultProps = {
    color: "text",
    width: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    spin: false,
};

export default Svg;
